import { DeliveryApi, OrderfulApi } from '@m4a3/api-client';
import { getEnvironment } from './environment';
import { getLatestJwtToken } from './amplify-auth';

/**
 * Centralized API instances to avoid multiple instantiations and token refreshes
 * All components should import from here instead of creating their own instances
 */

// Singleton instances - created once and reused across the application
export const deliveryApi = new DeliveryApi(getEnvironment());
export const orderfulApi = new OrderfulApi(getEnvironment(), '', getLatestJwtToken);

